import { DateTime } from 'luxon';

import { EntityBackupDefinitionApi } from '@apps/auth/api/models/back/entity-backup-definition-api';

export class EntityBackupDefinition
{
    masters: EntityMaster[];
    entityId: string;
    active: boolean;
    createdAt: DateTime;
    modifiedAt?: DateTime;

    static mapperFromApi (defApi: EntityBackupDefinitionApi): EntityBackupDefinition
    {
        const def: EntityBackupDefinition = Object.assign(new EntityBackupDefinition(), defApi);

        return def;
    }
}

export class EntityMaster
{
    masterName: string;
    policyPrefix: string;
}